import * as React from "react";
import { connect } from "react-redux";
import { Scrollspy, ScrollspyNavLink } from "reactstrap-scrollspy";
import { Nav, NavItem, NavLink } from "reactstrap";
import _ from 'lodash';
import { Link } from "react-router-dom";
import Autocomplete from "react-autocomplete";
import * as d from "../../reducers/domainReducer";
import SectionLoadingError from "../common/SectionLoadingError";

class FAQ extends React.Component {
    constructor(props) {
        super(props);
        this.state = { stickyNavClass: "" };
        this.onPageLoad = this.onPageLoad.bind(this);
        this.throttle = _.throttle(this.handleStickyNav.bind(this), 150, { maxWait: 100 });
        this.onMenuClick = this.onMenuClick.bind(this);
    }

    componentDidMount() {
        //    if (this.isHashMyChart()) {
        //        this.updateScrollToView(); //call it for initial render.
        //    }
        if (typeof window !== 'undefined') {
            window.addEventListener('load', this.onPageLoad);
            window.addEventListener('scroll', this.throttle);
            this.handleStickyNav();
        }

        this.onPageLoad();

        this.historyUnlisten = this.props.history.listen((location, action) => {
            if (location.pathname === this.props.history.location.pathname) {
                setTimeout(() => this.scrollIntoView(), 200);
            }
        });
    }

    //componentDidUpdate() {
    //    if (this.isHashMyChart()) {
    //        this.updateScrollToView();
    //    }
    //}

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('load', this.onPageLoad);
            window.removeEventListener('scroll', this.throttle);
        }
        if (this.historyUnlisten) {
            this.historyUnlisten();
        }
    }

    isMobile() {
        const windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
        return windowWidth && (windowWidth < 768);
    }

    getHash() {
        const { location } = this.props;
        return location && location.hash ? decodeURI(location.hash.substr(1).trim()).toLowerCase() : ""
    }

    scrollIntoView() {
        const faqHash = this.getHash();

        if (faqHash) {
            const element = document.getElementById(faqHash);
            const isSubQ = (faqHash.indexOf("-q") !== -1);
            const yOffset = -90;

            if (element) {
                if (isSubQ) {
                    const scrollY = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    //window.scrollTo({ top: scrollY });
                    document.documentElement.scrollTop = scrollY;
                    if (document.documentElement.scrollTop === 0) {
                        document.body.scrollTop = scrollY;
                    } 
                } else {
                    element.scrollIntoView();
                }
            } else if (this.isMobile()) {
                window.scrollTo({ top: 0 });
            }
        }
   }

    onPageLoad() {
        // wait until the page is rendered and scroll into view
        setTimeout(() => this.scrollIntoView(), 1000);
    }

    //isHashMyChart() {
    //    const { hash } = (typeof window !== 'undefined') ? window.location : "";
    //    if (typeof hash !== "undefined" && hash !== '') {
    //        const hashQueryString = hash.replace('#', '');
    //        var myArray = hashQueryString.split('&');
    //        if (myArray[0] && myArray[0] === 'MyChart') { //checking only for MyChart nothing else.
    //            return true;
    //        }
    //    }
    //    return false;
    //}

    //updateScrollToView() {
    //    const { hash } = (typeof window !== 'undefined') ? window.location : "";
    //    if (typeof hash !== "undefined" && hash !== '') {
    //        const hashQueryString = hash.replace('#', '');
    //        var myArray = hashQueryString.split(/[&?]+/);
    //        const id = myArray.length > 1 && myArray[1];
    //        const element = document.getElementById(id);
    //        if (element) element.scrollIntoView();
    //    }
    //}

    getFaq() {
        const { faq, location } = this.props;
        if (faq && faq.list && faq.list.length > 0) {
            const param = '?topic=';
            const topicIndex = location.search.indexOf(param);
            const topic = topicIndex > -1 ? decodeURI(location.search.substr(topicIndex + param.length)).trim().toLowerCase() : null;
            if (topic) {
                for (let i = 0; i < faq.list.length; i++) {
                    if (faq.list[i].questionText.trim().toLowerCase() === topic) {
                        this.activeFaqIndex = i;
                        return faq.list[i];
                    }
                }
            }
            this.activeFaqIndex = 0;
            return faq.list[0];
        }
        return null;
    }

    loadFaqNames(faq) {
        const faqMenuNames = faq.list.map(item => item.questionText);
        if (faqMenuNames) {
            faqMenuNames.unshift("faq-menu");
        }
        return faqMenuNames;
    }

    loadFaq(faq, faqHash) {
        var faqId = "";
        if (faqHash) {
            const faqIdEnd = faqHash.indexOf("-q");
            if (faqIdEnd !== -1) {
                faqId = faqHash.substr(0, faqIdEnd);
            } else {
                faqId = faqHash;
            }
        }

        const faqContent = faq.list.map((item, index) => (
            <div key={index} id={(this.isMobile() ? "" : item.questionText.toLowerCase())} className={"faq-answer-group" + (item.questionText.toLowerCase() === faqId ? " faq-active" : "")}>
                <div className="row">
                    <div className="col-12">
                        <div className="faq-answer-icon"><span className={"svg-faq-" + item.questionOrder } /></div>
                        <h2 className="faq-answer-heading">{item.questionText}</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        {item.options && item.options.length && item.options.map((option, index) => (
                            <div key={index} dangerouslySetInnerHTML={{ __html: option.optionText }} />
                        ))}
                    </div>
                </div>
            </div>
        ));

        const faqMenuClass = "sticky-nav" + (faqHash ? " hide-menu" : "") + this.state.stickyNavClass;
        const faqMenu =
            <div id="faq-menu" className={faqMenuClass}>
                <Nav vertical>
                    {faq.list.map((item, index) => (
                        <NavItem key={index} onClick={(e) => this.onMenuClick(e)}>
                            <ScrollspyNavLink name={item.questionText}>
                                <NavLink href={"#" + item.questionText.toLowerCase()}>
                                    <div className="faq-menu-icon"><span className={"svg-faq-" + item.questionOrder} /></div>
                                    {item.questionText}
                                </NavLink>
                            </ScrollspyNavLink>
                        </NavItem>
                    ))}
                </Nav>
            </div>;

        if (faqContent) {
            faqContent.unshift(faqMenu);
        }

        return faqContent;
    }

    onMenuClick(event) {
        if (this.isMobile()) {
            window.scrollTo({ top: 0 });
        }
    }

    handleStickyNav(event) {
        if (typeof window !== 'undefined') {
            const innerHeight = window.innerHeight;
            const offsetHeight = document && document.documentElement.offsetHeight ? document.documentElement.offsetHeight : 0;
            const scrollY = window.pageYOffset;
            const topOffsetHeight = 90;
            const isBottom = (innerHeight + scrollY + topOffsetHeight) >= offsetHeight;

            if ((scrollY > topOffsetHeight)) {
                this.setState({
                    scrollTopY: scrollY,
                    stickyNavClass: " sticky-nav-fixed" + (isBottom ? " sticky-nav-bottom" : "")
                });
            }
            else {
                this.setState({
                    scrollTopY: scrollY,
                    stickyNavClass: ""
                });
            }
        }
    }

    render() {
        const { faq } = this.props;
        const faqAvailable = faq && faq.list && faq.list.length;
        const faqMenuNames = faqAvailable ? this.loadFaqNames(faq) : "";
        const faqHash = this.getHash();
        const faqContent = faqAvailable ? this.loadFaq(faq, faqHash) : "";
        //const activeFaq = this.getFaq();

        return (
            <div className="container-fluid body-content need-help-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        {/*<div className="search">
                            <div className={"il-group autocomplete-group"}>
                                <Autocomplete wrapperStyle={{ display: 'flex' }}
                                    menuStyle={{
                                        borderRadius: '3px',
                                        boxShadow: '0 1px 7px 0 #C8C8C8',
                                        background: 'rgba(255, 255, 255, 0.9)',
                                        padding: '0',
                                        fontSize: '14px',
                                        position: 'fixed',
                                        overflow: 'auto',
                                        maxHeight: '250px',
                                        zIndex: '998'
                                    }}
                                    inputProps={{
                                        placeholder: "Search", className: "form-control",
                                        //onKeyUp: key => { if (key.keyCode === 13) this.search(value); },
                                        //onFocus: () => this.onFocus()
                                    }}
                                    items={[
                                        { label: 'Redesigned website', id: 1 },
                                        { label: 'Urgent Care Options', id: 2 }
                                    ]}
                                    //shouldItemRender={(item, value) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1}
                                    getItemValue={(item) => item.label}
                                    renderItem={(item, highlighted) =>
                                        (<div className="suggestion-item"
                                            key={item.id}
                                            style={{ backgroundColor: highlighted ? 'white' : 'white' }}>
                                            {item.label}
                                        </div>)
                                    }
                                    value={this.state.value}
                                    onChange={(e) => this.setState({ value: e.target.value })}
                                    onSelect={(value) => this.setState({ value })}
                                />
                                <div className="il-label" aria-hidden="true">Search</div>
                                <div className="input-icon-append">
                                    <span className="icon-search" />
                                </div>
                            </div>
                        </div>*/}

                        <div className="row">
                            <div className="col-6">
                                <div className="page-heading">Need Help?</div>
                            </div>
                            {faqHash !== "" &&
                                <div className="col-6 text-right mobile-element see-all-menu-link">
                                    <Link to="/faq" onClick={(e) => this.onMenuClick(e)}>SEE ALL</Link>
                                </div>
                            }
                        </div>

                        <div className="row need-help__content">
                            {faqContent &&
                                <div className="col-12">
                                    <Scrollspy
                                        names={faqMenuNames}
                                        homeIndex={1}
                                        topOffset="30%"
                                        bottomOffset="60%"
                                        children={faqContent}
                                    />
                                </div>
                            }
                            {faq && faq.error &&
                                <div className="col-12"><SectionLoadingError message="Failed to load. Please try again." /></div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        myChartFaqDocsData: state.docs.docsData,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        zipnosisEvisitVisitsUrl: state.session.serverData ? state.session.serverData.zipnosisEvisitVisitsUrl : "",
        zipnosisEvisitFAQUrl: state.session.serverData ? state.session.serverData.zipnosisEvisitFAQUrl : "",
        isLoggedIn: state.domain.li,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        faq: state.docs.faq
    };
};

export default connect(mapStateToProps)(FAQ);